import { CheckCircleIcon } from "@heroicons/react/solid";
import CalendarScheduleSlotModel from "../../../models/CalendarScheduleSlotModel";
import CompactSlotTitle from "../CompactSlotTitle";
import { Popover } from "@headlessui/react";

export default function CompactDoneSlot({
  slot,
  onClick,
  setOpen,
}: {
  slot: CalendarScheduleSlotModel;
  onClick: (slot: CalendarScheduleSlotModel) => void;
  setOpen?: () => void;
}) {
  return (
    <button
      role="button"
      className="w-full  h-full px-1 py-0.5  rounded-md bg-white  "
      onClick={!!setOpen ? setOpen : () => {}}
    >
      <div
        role="button"
        onClick={() => onClick(slot)}
        className="hover:bg-gray-50 border px-2 py-1  h-full  border-green-400 w-full  overflow-y-auto rounded-md bg-white "
      >
        <p className="text-green-700 text-xs leading-5 font-normal flex items-center justify-between truncate">
          <CompactSlotTitle slot={slot} />
          <CheckCircleIcon
            className="h-5 w-5 text-green-400"
            aria-hidden="true"
          />
        </p>
      </div>
    </button>
  );
}
